/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import PageWrapper from '../../../../modules/PageWrapper';
import {observer} from 'mobx-react';
import {useStore} from '../../../../../store/store';
import Filters from '../../../../table/new/filters/Filters';
import Presets from '../../../../table/new/Presets';
import {getFilters} from './getFilters';
import {facebookStatisticsFilters} from './filtersConfigs';
import {facebookStatisticsGroups} from './groupsConfigs';
import TableWrapper from '../../../../table/new/TableWrapper';
import Columns from '../../../../table/new/Columns';
import {baseFields} from '../../../../table/new/customizationTable';
import BlankSheet from '../../../../table/new/BlankSheet';
import FullScreen from '../../../../table/new/FullScreen';
import Refresh from '../../../../table/new/Refresh';
import ResultsCount from '../../../../table/new/ResultsCount';
import Search from '../../../../table/new/SearchForTable';
import {AddBrandModal, AddBrand} from './AddBrandModal';
import {CreateAppModal} from '../../../../../_metronic/partials';

const Brands = () => {
  const store = useStore();
  const [prevTimeConfig, setPrevTimeConfig] = useState(null);
  const [editItemId, setEditItemId] = useState(null);
  const [showCreateAppModal, setShowCreateAppModal] = useState(false);
  const [warning, setWarning] = useState(false);
  const [save, setSave] = useState(false);

  useEffect(() => {
    if (editItemId !== null) {
      setShowCreateAppModal(true);
      setSave(false);
    }
  }, [editItemId]);

  return (
    <PageWrapper
      firstTimeConfig='7day'
      prevTimeConfig={prevTimeConfig}
      breadcrumbs={[
        {title: 'Партнеры'},
        {isSeparator: true},
        {title: 'Бренды', path: '/advertisers/brands', isActive: true},
      ]}
      title={'Бренды'}
    >
      <TableWrapper
        setPrevTimeConfig={setPrevTimeConfig}
        prevTimeConfig={prevTimeConfig}
        getMethod={'Advertisers/getAdvertisersTable'}
        getFilters={getFilters}
        setEditItemId={setEditItemId}
        edit={'/advertisers/brands/'}
        defaultFilters={[
          {filter: 'advertiser_id', isFixed: true, options: []},
          {filter: 'brand_id', isFixed: true, options: []},
          {filter: 'offer_id', isFixed: true, options: []},
          {filter: 'type', isFixed: true, options: []},
          {filter: 'state', isFixed: true, options: ['recently_created', 'with_data']},
        ]}
        defaultGroups={[
          {group: 'brand', isFixed: true},
          {group: 'offer', isFixed: false},
          {group: 'landing', isFixed: false},
        ]}
        //на випадок якщо нам взагалі не потрібно показувати вибір груп
        hasHiddenGroups={false}
        baseFields={baseFields.filter((item) => item.value !== 'clicks')}
        disabledByDefault={[
          'lead2appeal',
          'lead2fd',
          'chat2reg',
          'chat2fd',
          'chat2cpa',
          'reg2fd',
          'fd2cpa',
          'reg2rs',
          'chat2rs',
          'lead2rs',
          'click2rs',
        ]}
      >
        <CreateAppModal
          customWidth='mw-550px'
          show={showCreateAppModal}
          handleClose={() => {
            if (save) {
              setShowCreateAppModal(false);
              setEditItemId(null);
            } else {
              setWarning(true);
            }
          }}
          title='Изменения бренда'
        >
          <AddBrand
            show={setShowCreateAppModal}
            warning={warning}
            setWarning={setWarning}
            id={editItemId}
            isUpdate
          />
        </CreateAppModal>
        <Filters
          facebookStatisticsFilters={facebookStatisticsFilters}
          facebookStatisticsGroups={facebookStatisticsGroups}
          childrenNearGroups={
            <>
               {!(store.roles.includes(13) || store.roles.includes(32)) && <AddBrandModal />}
              <Search />
            </>
          }
          childrenPresets={
            <>
              <ResultsCount />
              <BlankSheet />
              <Columns />
              <Presets />
              <FullScreen />
            </>
          }
          childrenHead={false}
          childrenRefresh={false}
          childrenByFilters={<Refresh />}
        />
      </TableWrapper>
    </PageWrapper>
  );
};

export default observer(Brands);
